// extracted by mini-css-extract-plugin
export var animating = "_2p-3";
export var background = "_2p-6";
export var constrainHeight = "_2p-2";
export var dark = "_2p-4";
export var dropdown = "_2p-1";
export var leave = "_2p-5";
export var option = "_2p-7";
export var root = "_2p-0";